(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["arvani-adhd-support"] && !Shopify.designMode) return;
  try {
    
(() => {
  let queued = false;
  const update = () => {
    queued = false;
    document.querySelectorAll('.ah-journey-timeline').forEach(timeline => {
      const steps = Array.from(timeline.querySelectorAll('.ah-journey-step'));
      steps.forEach(step => {
        const heading = step.querySelector('.ah-journey-week');
        if (!heading) return;
        const active = heading.getBoundingClientRect().top <= window.innerHeight * 0.6;
        step.classList.toggle('is-highlighted', active);
      });
    });
  };
  const schedule = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(update);
  };
  document.addEventListener('scroll', schedule, { passive: true, capture: true });
  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule);
  window.addEventListener('pageshow', schedule);
  document.addEventListener('shopify:section:load', schedule);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule, { once: true });
  else schedule();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["arvani-afternoon-fatigue"] && !Shopify.designMode) return;
  try {
    
(() => {
  let queued = false;
  const update = () => {
    queued = false;
    document.querySelectorAll('.ah-journey-timeline').forEach(timeline => {
      const steps = Array.from(timeline.querySelectorAll('.ah-journey-step'));
      steps.forEach(step => {
        const heading = step.querySelector('.ah-journey-week');
        if (!heading) return;
        const active = heading.getBoundingClientRect().top <= window.innerHeight * 0.6;
        step.classList.toggle('is-highlighted', active);
      });
    });
  };
  const schedule = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(update);
  };
  document.addEventListener('scroll', schedule, { passive: true, capture: true });
  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule);
  window.addEventListener('pageshow', schedule);
  document.addEventListener('shopify:section:load', schedule);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule, { once: true });
  else schedule();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["arvani-everyday-support"] && !Shopify.designMode) return;
  try {
    
(() => {
  let queued = false;
  const update = () => {
    queued = false;
    document.querySelectorAll('.ah-journey-timeline').forEach(timeline => {
      const steps = Array.from(timeline.querySelectorAll('.ah-journey-step'));
      steps.forEach(step => {
        const heading = step.querySelector('.ah-journey-week');
        if (!heading) return;
        const active = heading.getBoundingClientRect().top <= window.innerHeight * 0.6;
        step.classList.toggle('is-highlighted', active);
      });
    });
  };
  const schedule = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(update);
  };
  document.addEventListener('scroll', schedule, { passive: true, capture: true });
  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule);
  window.addEventListener('pageshow', schedule);
  document.addEventListener('shopify:section:load', schedule);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule, { once: true });
  else schedule();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["arvani-focus-concentration"] && !Shopify.designMode) return;
  try {
    
(() => {
  let queued = false;
  const update = () => {
    queued = false;
    document.querySelectorAll('.ah-journey-timeline').forEach(timeline => {
      const steps = Array.from(timeline.querySelectorAll('.ah-journey-step'));
      steps.forEach(step => {
        const heading = step.querySelector('.ah-journey-week');
        if (!heading) return;
        const active = heading.getBoundingClientRect().top <= window.innerHeight * 0.6;
        step.classList.toggle('is-highlighted', active);
      });
    });
  };
  const schedule = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(update);
  };
  document.addEventListener('scroll', schedule, { passive: true, capture: true });
  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule);
  window.addEventListener('pageshow', schedule);
  document.addEventListener('shopify:section:load', schedule);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule, { once: true });
  else schedule();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["arvani-home"] && !Shopify.designMode) return;
  try {
    
(() => {
  let queued = false;
  const update = () => {
    queued = false;
    document.querySelectorAll('.ah-journey-timeline').forEach(timeline => {
      const steps = Array.from(timeline.querySelectorAll('.ah-journey-step'));
      steps.forEach(step => {
        const heading = step.querySelector('.ah-journey-week');
        if (!heading) return;
        const active = heading.getBoundingClientRect().top <= window.innerHeight * 0.6;
        step.classList.toggle('is-highlighted', active);
      });
    });
  };
  const schedule = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(update);
  };
  document.addEventListener('scroll', schedule, { passive: true, capture: true });
  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule);
  window.addEventListener('pageshow', schedule);
  document.addEventListener('shopify:section:load', schedule);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule, { once: true });
  else schedule();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
